// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-div, .waiting-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.loading-game-spinner {
  position: relative;
  width: 300px;
  height: 300px;
}

.game-spinner {
  box-sizing: border-box;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  animation: spin 1s linear infinite;
}

.loading-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 36px;
  color: white;
  font-family: 'Kim';
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.orientation-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;
}

.orientation-overlay__text {
  font-size: 1.5em;
  margin-top: 20px;
  font-family: 'Kim';
}

.waiting-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.waiting-div {
  font-family: 'Kim';
  font-size: 24px;
  margin-bottom: 20px;
}

@keyframes ellipsis {
  0% { content: ''; }
  25% { content: '.'; }
  50% { content: '..'; }
  75% { content: '...'; }
  100% { content: ''; }
}

.waiting-div::after {
  content: '';
  display: inline-block;
  width: 12px;
  animation: ellipsis 2s infinite steps(1);
}

#scene {
  background: linear-gradient(to bottom, #242529, #325268);
  margin: 0;
  padding: 0; 
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/routes/GamePage.style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,MAAM,YAAY,EAAE;EACpB,MAAM,aAAa,EAAE;EACrB,MAAM,cAAc,EAAE;EACtB,OAAO,WAAW,EAAE;AACtB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,wDAAwD;EACxD,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".loading-div, .waiting-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1000;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.loading-game-spinner {\n  position: relative;\n  width: 300px;\n  height: 300px;\n}\n\n.game-spinner {\n  box-sizing: border-box;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #3498db;\n  border-radius: 50%;\n  width: 100%;\n  height: 100%;\n  animation: spin 1s linear infinite;\n}\n\n.loading-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 36px;\n  color: white;\n  font-family: 'Kim';\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.orientation-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.8);\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  z-index: 9999;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.orientation-overlay__text {\n  font-size: 1.5em;\n  margin-top: 20px;\n  font-family: 'Kim';\n}\n\n.waiting-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.waiting-div {\n  font-family: 'Kim';\n  font-size: 24px;\n  margin-bottom: 20px;\n}\n\n@keyframes ellipsis {\n  0% { content: ''; }\n  25% { content: '.'; }\n  50% { content: '..'; }\n  75% { content: '...'; }\n  100% { content: ''; }\n}\n\n.waiting-div::after {\n  content: '';\n  display: inline-block;\n  width: 12px;\n  animation: ellipsis 2s infinite steps(1);\n}\n\n#scene {\n  background: linear-gradient(to bottom, #242529, #325268);\n  margin: 0;\n  padding: 0; \n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
